import DeclineMeetingComponent from './DeclineMeetingComponent'

export default DeclineMeetingComponent
